import type { TextFieldProps } from '@mui/material';
import type { ResolvedField } from './types';

/**
 * The MUI TextField props every text-like type starts from — the one place
 * that decides how a field looks, so all of them look the same.
 */
export function textFieldProps(field: ResolvedField<unknown>, error?: string): TextFieldProps {
  const slots = field.slotProps ?? {};
  return {
    name: field.name,
    label: field.label,
    placeholder: field.placeholder,
    required: field.required,
    disabled: field.disabled,
    size: field.size,
    variant: field.variant,
    fullWidth: field.fullWidth,
    className: field.className,
    sx: field.sx,
    error: !!error,
    helperText: error ?? field.helperText,
    ...field.props,
    slotProps: {
      ...slots,
      inputLabel: { ...(field.shrinkLabel ? { shrink: true } : {}), ...(slots.inputLabel as object) },
      htmlInput: { readOnly: field.readOnly, ...field.attrs, ...(slots.htmlInput as object) },
    },
  } as TextFieldProps;
}
